export default "__VITE_ASSET__Cm5LAoLW__"